import { GridStateCommunity } from '../../../models/gridStateCommunity'

// TODO v6: rename to gridEditingStateSelector
export const gridEditRowsStateSelector = (state: GridStateCommunity) =>
  state.editRows
